const KNOWN_ERRORS = [
    {
        key: 'already linked',
        message: 'These credentials are already linked to another account.'
    },
    {
        key: 'info not found',
        message: 'Your Client ID or Client Secret may be incorrect. Please try again.'
    }
];
export const getErrorMessage = (error) => {
    const matchedError = KNOWN_ERRORS.find(({ key }) => error.toLowerCase().includes(key));
    return matchedError ? matchedError.message : 'An unknown error occurred';
};
